import { IdentityEndpoints } from '@anecdotes/identity-data-access';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AbstractIdentityConfigService } from '../../abstract-identity-config/abstract-identity-config.service';
import { trim } from '../../../utils';

const defaultSeparator = '/';
const backSlash = '\\';

@Injectable()
export abstract class AbstractService {
  constructor(protected http: HttpClient, protected configService: AbstractIdentityConfigService) {}

  protected buildUrl(
    enpointSelector: (endpointConfig: IdentityEndpoints) => string,
    params?: { [key: string]: number | string | boolean }
  ): string {
    const baseUrl = trim(this.configService.getConfig().identityApi.baseUrl.replace(backSlash, defaultSeparator), defaultSeparator);
    const endpoint = trim(
      enpointSelector(this.configService.getConfig().identityApi.endpoints).replace(backSlash, defaultSeparator),
      defaultSeparator
    );

    return this.createResultUrl(baseUrl, endpoint, params);
  }

  private createResultUrl(
    baseUrl: string,
    endpoint: string,
    params?: { [key: string]: number | string | boolean }
  ): string {
    return `${baseUrl}${defaultSeparator}${this.setParams(endpoint, params)}`;
  }

  private setParams(endpoint: string, params: { [key: string]: number | string | boolean }): string {
    if (params) {
      Object.keys(params).forEach((key) => {
        if (params[key]) {
          endpoint = endpoint.replace(`{{${key}}}`, params[key].toString());
        }
      });
    }

    return endpoint;
  }
}
